///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export enum ProductsRadioTabsEnum {
    GENERAL,
    PRODUCT_CONFIG,
    NW_CONFIG
}
